"use client";

import { useCallback, useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import type { ExchangeSessionResult } from "../types";
import { useHibachiConnection } from "./useHibachiConnection";

export function useHibachiSession(): ExchangeSessionResult {
  const hibachiConnection = useHibachiConnection();

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const selectedAccount = useMemo(() => {
    const accts = hibachiConnection.hibachiAccounts;
    if (selectedAccountId != null) return accts.find((a) => a.id === selectedAccountId) ?? null;
    return accts[0] ?? null;
  }, [hibachiConnection.hibachiAccounts, selectedAccountId]);

  const setSelectedAccount = useCallback(
    (account: HubExchangeAccount | null) => setSelectedAccountId(account?.id ?? null),
    [],
  );

  return {
    connection: hibachiConnection,
    sessionStatus: hibachiConnection.sessionStatus,
    accounts: hibachiConnection.hibachiAccounts,
    selectedAccount,
    setSelectedAccount,
    handleSetupAction: () => {},
    isSettingUp: false,
    requiredWalletRole: null,
    requiredWalletAddress: hibachiConnection.connectedAddress,
    exchangeAccountAddress: hibachiConnection.connectedAddress,
    needsDeposit: false,
  };
}
